import { vars } from '../../theme';
import React from 'react';
import HBBannerBase from '../HBBanner/HBBannerBase';
import { CheckCircle24 } from '@honeybook/icons';
import type { buttonThemes } from '../HBButton/HBButton.styles';
import {
    HBBannerProps,
    TBannerActionThemeLimited
} from '../HBBanner/HBBanner.types';
import { MustIncludeOneOfBasicTestIdProps } from '../common/internal/test-id.types';

export interface Props extends Omit<HBBannerProps, 'hideIcon'> {
    /** Button style for actions: 'primary' renders filled primary buttons, 'secondary' renders outlined buttons. Defaults to 'primary'. */
    actionsTheme?: TBannerActionThemeLimited;
    /** HBButton theme applied to the primary action button: 'primary' for main CTA, 'secondary-solid-secondary' for secondary actions, 'button-link' for inline link-style actions. */
    primaryActionTheme?:
        | 'secondary-solid-secondary'
        | 'button-link'
        | 'primary';
}

const ACTION_THEME_TO_BUTTON_THEME: Record<
    TBannerActionThemeLimited,
    keyof typeof buttonThemes
> = {
    primary: 'primary',
    secondary: 'secondary-solid-secondary'
};

const SuccessBanner = ({
    actionsTheme = 'primary',
    ...props
}: Props & MustIncludeOneOfBasicTestIdProps) => {
    return (
        <HBBannerBase
            icon={CheckCircle24}
            primaryActionTheme={ACTION_THEME_TO_BUTTON_THEME[actionsTheme]}
            {...props}
            actionsTheme={actionsTheme}
            accentLine={vars.colors.base.success}
            background={vars.colors.surface.success}
        />
    );
};

export default SuccessBanner;
